import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "19d58fcd-dd5d-4c73-8b20-3e5d0e2f1d5f",
  publicId: "20",
  name: "Binaural Unmasking",
  difficulty: 2,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, task01],
};

export default lesson;
